import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';

import { first } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { UserDataService } from 'src/app/features/user-data.service';
import { MailCenterService } from 'src/app/mail-center/mail-center.service';

@Component({
  selector: 'app-country-record',
  templateUrl: './country-record.component.html',
  styleUrls: ['./country-record.component.css']
})
export class CountryRecordComponent implements OnInit {
  status:string=""; //deciding the shown material
  statusList:any;//list of the status records
  keyCode:any;
  inventionDetailData!:any;
  companyData:any; inventorData:any;attorneyData:any;rdCenter:any;project:any;
  visible=false;
  visibleSummary=false;
  visibleDocuments=false;
  visibleTimeLimits=false;
  visibleDecision=false;
  visibleRecord=false;
  visiblePatents=false;
  visibleRegistrationDate=false;
  visibleApplicationDate=false;
  docType="";
  inventionName:any;
  documentNumber:any;
  inventionDate:any;
  path="";
  myRadio="";
  isFolderLoaded=false;
  isStatusUpdated=false;
  valid=false;
  fileName="";
  errorCode="";
  error=true;
  errorText:string=""
  errorText1:string=""
  docLink:any=[];
  notes:any;
  patentInfo:any;
  toggle=false;
  foldertoggle=false;
  otherForm=false;
  firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/patent-book.appspot.com/o/";
  firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8";
  inventionType="";
  number=0;
  selectedCountry:any=[];
  countryLastStatus:any;
  countryRecLastStatus="";
  addPatentNumberField=false;
  countryLastInventionType:any;
  countryStatusList:any;
  countryDocLink:any=[];
  countryRecordDate="";
  countryApplicationDate="";
  countryPatentNumber="";
  //firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8"; Old
  //firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/sisecam-a8421.appspot.com/o/"; Old
  loggedUser="";
  randomNumber=0;
  constructor( private userData:UserDataService, private auth:AuthService,  private route:Router, private af:AngularFireStorage,private mailService:MailCenterService, private activatedRoute:ActivatedRoute) { }


   ngOnInit(): void {

  }

  ngAfterContentInit(){
    this.number=this.userData.number;
    this.loggedUser=this.auth.userMail;
    //console.log(this.number);
    this.randomNumber=Math.floor((Math.random() * 100000) + 1);
    console.log(this.randomNumber);
    this.keyCode=this.userData.key;
    this.visibleSummary=true;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].CompanyData;
      this.attorneyData= this.inventionDetailData[0].AttorneyData;
      this.rdCenter=this.inventionDetailData[0].rdCenter;
      this.project=this.inventionDetailData[0].project;
      this.inventorData=this.inventionDetailData[0].inventorData;
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.statusList=this.inventionDetailData[0].status;
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
      this.notes=this.inventionDetailData[0].hasOwnProperty('notes') ? this.notes= this.inventionDetailData[0].notes : this.notes="not yok";

      this.visible=true;

      //Country records
      this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
      this.selectedCountry=this.patentInfo[this.number];
      this.countryStatusList=this.selectedCountry.patentStatus;
      this.countryLastStatus=this.selectedCountry.patentStatus.slice(-1)[0].status;

     // if(this.countryLastStatus=="Tescil") {this.visibleRegistrationDate=true;}



this.countryRecordDate=this.countryLastStatus[1];
      this.countryLastInventionType=this.selectedCountry.patentType;
      this.countryDocLink=this.selectedCountry.hasOwnProperty('countryDocLink')? this.countryDocLink= this.selectedCountry.countryDocLink : this.countryDocLink=[];
      //console.log (this.selectedCountry);
      //console.log (this.countryStatusList);
      console.log (this.countryLastInventionType);

      })
      }
//
    navigate(){


      this.route.navigate(["patentList/",this.inventionDetailData[0].documentNumber]);

      this.userData.getKey(this.keyCode);}
    visibleRegistration(){this.visibleRegistrationDate=true}
    visibleApplication(){this.visibleApplicationDate=true}
    summary(){
      this.visibleSummary=true;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;

    }

    documents(){
      this.visibleSummary=false;
      this.visibleDocuments=true;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;

    }
    timeLimits(){
      //console.log("timeLimits");
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=true;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;

    }
    decision(){
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=true;
      this.visibleRecord=false;
      this.visiblePatents=false;

    }
    patentRecords() {
      this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=true;

    }
    addNote() {  this.visibleSummary=false;
      this.visibleDocuments=false;
      this.visibleTimeLimits=false;
      this.visibleDecision=false;
      this.visibleRecord=false;
      this.visiblePatents=false;
      }
      countryEdit() {
        this.route.navigate(['edit'],{relativeTo:this.activatedRoute});
      }
    recordPatent() {
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'recordPatent']);
      this.userData.getKey(this.keyCode);
    }
    checkTheLastSatusForPatentNumber($event:any){if($event=="tescil" ||$event=="başvuru" ||$event=="yayın"  ){this.addPatentNumberField=true}
     }
    //Sadece Başvuru olarak güncellenirse ilk ve son kayıda atacak böylece patent son durumu güncel tutulacak ve patentin ilk durumu güncellenmiş başvuru tarihi olacak
    updateStatus(){
      this.patentInfo[this.number].patentType=this.countryLastInventionType;
    this.isStatusUpdated=true;
      this.onToggle();
      this.inventionName=this.inventionName.toLowerCase();
      this.notes=this.notes.toLowerCase();
     // console.log(this.value);
     if(this.countryRecLastStatus=="tescil") {this.countryLastStatus=["tescil",this.countryRecordDate, this.countryPatentNumber];
     console.log("tescil")
     this.patentInfo[this.number].patentStatus.push({status:this.countryLastStatus, date:Date.now(), recordigUser:this.loggedUser});}
     else if(this.countryRecLastStatus=="iptal") {this.countryLastStatus=["iptal", this.countryRecordDate,this.countryPatentNumber];
     console.log("iptal")
     this.patentInfo[this.number].patentStatus.push({ status:this.countryLastStatus, date:Date.now(), recordigUser:this.loggedUser});}
     else if(this.countryRecLastStatus=="yayın") {this.countryLastStatus=["yayın", this.countryRecordDate,this.countryPatentNumber];
     console.log("iptal")
     this.patentInfo[this.number].patentStatus.push({ status:this.countryLastStatus, date:Date.now(), recordigUser:this.loggedUser});}
     else if(this.countryRecLastStatus=="başvuru") {this.countryLastStatus=["başvuru", this.countryRecordDate,this.countryPatentNumber];
     console.log("başvuru")

     this.patentInfo[this.number].patentStatus.unshift({ status:this.countryLastStatus, date:Date.now(), recordigUser:this.loggedUser});
     this.patentInfo[this.number].patentStatus.push({ status:this.countryLastStatus, date:Date.now(), recordigUser:this.loggedUser});}
    else{console.log("diğer")
      this.patentInfo[this.number].patentStatus.splice(1,0,({status:[this.countryRecLastStatus, this.countryRecordDate], date:Date.now(), recordigUser:this.loggedUser}));

     }



      //console.log(this.statusList)
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
        this.errorText1="Buluş Güncellendi!"
        alert("Buluş Güncellendi")},
        err=>{
        this.errorText1 = err.statusText;
        alert("Buluş GÜNCELLENEMEDİ")
        console.log(this.error)});

    }
    deleteStatusRecord(i:number){console.log( this.patentInfo[this.number].patentStatus[i]);
      this.patentInfo[this.number].patentStatus.splice(i,1);
      console.log( this.patentInfo[this.number].patentStatus[i]);
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
        this.errorText1="Buluş Güncellendi!"
        alert("Buluş Güncellendi")},
        err=>{
        this.errorText1 = err.statusText;
        alert("Buluş GÜNCELLENEMEDİ")
        console.log(this.error)});}
   /* updateStatusSendEmail() {
      const time=(Math.round((Date.now()/1000)+300)); //300 for delay
     // console.log(this.value);
     this.isStatusUpdated=true;
     this.onToggle();
      switch(this.value) {
        case "1":
          this.value="Başvuru"
          break;
        case "2":
          this.value="Süreç Devam Ediyor"
          break;
        case "3":
          this.value="İptal"
          break;
        case "4":
          this.value="Tescil"
          break;
         default:
          this.value=this.value
      }
      this.patentInfo[this.number].patentStatus.push({status:this.value, date:Date.now(), recordigUser:this.loggedUser});
      //console.log(this.statusList)
      this.userData.updateInvention(this.companyData,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
        //console.log(arr);
        this.errorText1="Buluş Güncellendi!";
        alert("Buluş Güncellendi")},
        err=>{
        this.errorText1 = "Yetkiniz bulunmamaktadır";
        alert("Güncelleme Yetkiniz bulunmamaktadır")
        console.log(this.error)});
        for (var val of this.inventorData) {
          let shareText=""
          if (val.share<1) {shareText="henüz belirlenmemiştir." } else {shareText=val.share+"/100"}
          this.mailService.sendStatusUpdate(val.name, this.inventionName, this.status, val.share,val.mail,time)
          .pipe(first())
          .subscribe(resp => {
            //console.log({ resp });
          }, err => {
            console.error({ err });
          });
        }
    }*/
    uplodFolder(){
      this.inventionName=this.inventionName.toLowerCase();
      this.notes=this.notes.toLowerCase();
      //console.log(this.countryDocLink);
      this.error=true;
     this.valid=true;
      this.errorText="";
      this.af.upload("files/"+this.documentNumber+"/"+this.selectedCountry.patentCountry+"/"+this.myRadio+"/"+this.fileName+"/"+this.randomNumber,this.path);
      this.countryDocLink.push({link:this.firebaseStorageLink+"files%2F"+this.documentNumber+"%2F"+this.selectedCountry.patentCountry+"%2F"+this.myRadio+"%2F"+this.fileName+"%2F"+this.randomNumber+this.firebaseStorageLink2,date:Date.now(),docName:this.fileName, type:this.myRadio});
      this.patentInfo[this.number].countryDocLink=this.countryDocLink;
      this.onFolderToggle();
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Dosya Yüklenmiştir";
          alert("Dosya Yüklenmiştir")
        },
        err=>{
        this.errorText=err.statusText;
        alert("Dosya YÜKLENEMEMİŞTİR")
        console.log(this.errorText)});

    }
    deleteFolder(i:number){
      this.inventionName=this.inventionName.toLowerCase();
      this.notes=this.notes.toLowerCase();
      if(confirm(this.inventionName+" buluşuna ait " + this.patentInfo[this.number].patentCountry +" ülke girişindeki dosya silinsin mi?")){
      this.userData.deletionRecords([this.loggedUser,Date.now()],'ülkesel dosya kaydı silindi', `dosyanın silindiği buluş : ${this.inventionName}, Dosyanın silindiği ülke : ${this.patentInfo[this.number].patentCountry}  `).subscribe();
      this.onFolderToggle();
      this.af.refFromURL(this.countryDocLink[i].link).delete();
      this.countryDocLink.splice(i, 1);
      //console.log(this.countryDocLink);
      this.patentInfo[this.number].countryDocLink=this.countryDocLink;
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,
        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Ülkesel Dosya silinmiştir";
          alert("Ülkesel Dosya Silinmiştir")},
        err=>{
          this.errorText=err.statusText;
          alert("Ülkesel Dosya SİLİNEMEMİŞTİR")
          console.log(this.errorText)});;

    }}
    deletePatent(i:number){
      if(confirm(this.inventionName+" buluşundaki "+ this.patentInfo[i].patentCountry+ " ülke girişi silinsin mi?")){
      this.userData.deletionRecords([this.loggedUser,Date.now()],'ülke kaydı silindi', `silinen ülke: ${this.patentInfo[i].patentCountry} - Dosya No:${this.documentNumber} - Buluş Adı:${this.inventionName}`).subscribe();
      //console.log(this.loggedUser,this.selectedCountry);

     // this.af.refFromURL(this.docLink[i]?.link).delete(); NEEDS FİX
      this.patentInfo.splice(i, 1);
      //console.log(this.patentInfo);
      this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
        this.documentNumber,
        this.inventionName,
        this.inventionDate,
        this.inventorData,
        this.statusList,
        this.docLink,
        this.patentInfo,
        this.keyCode,

        this.notes
        ).
        subscribe(arr=>{
          //console.log(arr);
          this.errorText="Ülke kaydı silinmiştir";
          alert("Ülke kaydı silinmiştir")},
        err=>{
          this.errorText=err.statusText;
          alert("Ülke kaydı silinememiştir")
          console.log(this.errorText)});;

    }}
    enterCountry(i:number){
      this.number=i;

      this.selectedCountry=this.patentInfo[i];
      //console.log(this.selectedCountry);
      this.userData.getItemNumber(i);
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'countryRecord',this.patentInfo[i].patentCountry]);

    }
    upload($event:any){
      this.path=$event.target.files[0];
      this.isFolderLoaded=($event.isTrusted);
    }
    checkValidity(){
      if(this.myRadio =="buluş Durumu girilmedi" || this.path=="" || this.fileName=="") {
        this.valid=false;

        this.error=true;
        this.errorText="Dosyayı ekleyin ve dosya bilgilerini kontrol edin. "}
      else {this.valid=true;
        this.errorText="";}

    }
    onToggle() {this.toggle=!this.toggle;
      this.errorText1="";}
    onFolderToggle() {this.foldertoggle=!this.foldertoggle;
    this.errorText="";};
    mailCenter() {
      this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber,'mailCenter']);
      this.userData.getKey(this.keyCode);
    }
    formName() {
      this.otherForm=true;
    }

}
